import { BaseError } from './base';

type NotWaasWalletProviderErrorParams = {
  walletProviderKey: string;
};

export class NotWaasWalletProviderError extends BaseError {
  constructor({ walletProviderKey }: NotWaasWalletProviderErrorParams) {
    super({
      cause: null,
      code: 'not_waas_wallet_provider_error',
      docsUrl: null,
      name: 'NotWaasWalletProviderError',
      shortMessage: `Wallet provider ${walletProviderKey} is not a Dynamic WaaS wallet provider`,
    });
  }
}
